import {
  GET_SHOPWISE_PULSE_SUMMARY_REPORT
} from '../../../../Types'

const initialState = []

const ShopWisePulseReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHOPWISE_PULSE_SUMMARY_REPORT:
      return action.payload
    default:
      return state
  }
}
export default ShopWisePulseReportReducer